import { SpintrTypes } from "src/typings";

type Privilege = {
    value: boolean;
    privilegeId: number;
}

export function canAdministerAcademy(appState: Spintr.AppState): boolean {
    const profile = appState.profile.active;

    if (profile.isAdmin || profile.isEditor) {
        return true;
    }

    const privileges = appState.privileges.data || [];

    return privileges.some(
        (p: Privilege) => p.value &&
            p.privilegeId === SpintrTypes.Privilege.IsLearningAdministrator);
}
